import React from 'react'


const gis = () => {
    return (
        <div className="skills__content">
            <h3 className="skills__title">Tools / Others</h3>

            <div className="skills__box">
                <div className="skills__group">
                    <div className="skills__data">
                        <i className='bx bx-badge-check'></i>

                        <div>
                            <h3 className="skills__name">Github</h3>
                            <span className="skills__level">Intermediate</span>
                        </div>
                    </div>

                    <div className="skills__data">
                        <i className='bx bx-badge-check' ></i>

                        <div>
                            <h3 className="skills__name">Visual Studio Code</h3>
                            <span className="skills__level">Intermediate</span>
                        </div>
                    </div>

                     
</div>
<div className="skills__group">
    <div className="skills__data">
                        <i className='bx bx-badge-check' ></i>

                        <div>
                            <h3 className="skills__name">ETL</h3>
                            <span className="skills__level">Intermediate</span>
                        </div>
                    </div>
                    <div className="skills__data">
                        <i className='bx bx-badge-check' ></i>

                        <div>
                            <h3 className="skills__name">Data Pipeline</h3>
                            <span className="skills__level">Intermediate</span>
                        </div>
                    </div>
                </div>

                {/* <div className="skills__group">
                    <div className="skills__data">
                        <i className='bx bx-badge-check'></i>

                        <div>
                            <h3 className="skills__name">MySQL</h3>
                            <span className="skills__level">Intermediate</span>
                        </div>
                    </div>



                    <div className="skills__data">
                        <i className='bx bx-badge-check' ></i>

                        <div>
                            <h3 className="skills__name">PostgreSQL</h3>
                            <span className="skills__level">Intermediate</span>
                        </div>
                    </div>
                </div> */}
            </div>
        </div>
    )
}

export default gis